import {useSelector} from 'react-redux';
import {eventInEditMode} from '~/CreateFabricInvitation/reducers/details/selectors';
import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

export const isProOrPartyPassUser = (subscriptionPlanName: string | undefined) =>
  Boolean(
    subscriptionPlanName && [PLAN_NAME_PRO, PLAN_NAME_PARTY_PASS].includes(subscriptionPlanName)
  );

const STEP_4_UX_REFRESH_DESKTOP_EXP_NAME = 'test_step-4-refresh-desktop';
const STEP_4_UX_REFRESH_MW_EXP_NAME = 'test_step-4-refresh-mw';
export const isInStep4RefreshVariation = (isDesktop: boolean, readonly = true) => {
  const expName = isDesktop ? STEP_4_UX_REFRESH_DESKTOP_EXP_NAME : STEP_4_UX_REFRESH_MW_EXP_NAME;
  return evite.experiments.inVariation(expName, 'variant', false, readonly);
};

// Experiment name: "test_premium_upsell_content" cleanup ticket: EVT-36514
const PREMIUM_UPSELL_CONTENT_EXPERIMENT_NAME = 'test_premium-upsell-content';
export const useIsInPremiumUpsellContentVariation = (readonly = false) => {
  const experimentCookie = evite.experiments.getExperimentCookie(
    PREMIUM_UPSELL_CONTENT_EXPERIMENT_NAME
  );
  const isInViewInvitation = window.location.pathname.startsWith('/event/');
  const isInEditMode = useSelector(eventInEditMode);
  const isDesktop = useIsLargishAndUp();

  if (experimentCookie) {
    return experimentCookie === 'variant';
  }

  return (
    !isInViewInvitation &&
    !isInEditMode &&
    isDesktop &&
    evite.experiments.inVariation(
      PREMIUM_UPSELL_CONTENT_EXPERIMENT_NAME,
      'variant',
      false,
      readonly
    )
  );
};
